import React, {useCallback, useEffect, useState} from "react";
import {Button, Col, Modal, Row} from "react-bootstrap";
import Select from "react-select";
import {select} from "../../../../common/commonHandlers";
import {debounce} from "throttle-debounce";
import _ from 'lodash'

const JSAFilterModal = ({onHide, onSave, startFilters, searchForCustomer, searchForWorkOrders, searchForProposals}) => {
    const [filters, setFilters] = useState({})
    const [customerOptions, setCustomerOptions] = useState([])
    const [loadingCustomers, setLoadingCustomers] = useState(false)
    const [workOrderOptions, setWorkOrderOptions] = useState([])
    const [loadingWorkOrder, setLoadingWorkOrder] = useState(false)
    const [proposalOptions, setProposalOptions] = useState([])
    const [loadingProposal, setLoadingProposal] = useState(false)

    const customerDelayedSearch = useCallback(debounce(1500, (text, filters) => customerSearch(text, filters)), [])
    const workOrderDelayedSearch = useCallback(debounce(1500, (text, filters) => workOrderSearch(text, filters)), [])
    const proposalDelayedSearch = useCallback(debounce(1500, (text, filters) => proposalSearch(text, filters)), [])

    const customerSearch = (text, filters) => {
        if (text && text.length > 0) {
            setLoadingCustomers(true)
            searchForCustomer(text, (res) => {
                setLoadingCustomers(false)
                const result = filters?.customerIds && filters?.customerIds.length > 0 ? res.concat(filters?.customerIds) : res
                const uniqueResult = Array.from(new Set(result))
                setCustomerOptions(uniqueResult)
            })
        }
    }

    const workOrderSearch = (text, filters) => {
        if (text && text.length > 0) {
            setLoadingWorkOrder(true)
            searchForWorkOrders(text, (res) => {
                setLoadingWorkOrder(false)
                const result = filters?.workOrderIds && filters?.workOrderIds.length > 0 ? res.concat(filters?.workOrderIds) : res
                const uniqueResult = Array.from(new Set(result))
                setWorkOrderOptions(uniqueResult)
            })
        }
    }

    const proposalSearch = (text, filters) => {
        if (text && text.length > 0) {
            setLoadingProposal(true)
            searchForProposals(text, (res) => {
                setLoadingProposal(false)
                const result = filters?.proposalIds && filters?.proposalIds.length > 0 ? res.concat(filters?.proposalIds) : res
                const uniqueResult = Array.from(new Set(result))
                setProposalOptions(uniqueResult)
            })
        }
    }

    useEffect(() => {
        const newFilters = _.cloneDeep(startFilters)
        setFilters(newFilters)

        if (startFilters.customerIds && startFilters.customerIds.length > 0) {
            setCustomerOptions(startFilters.customerIds)
        }
        if (startFilters.workOrderIds && startFilters.workOrderIds.length > 0) {
            setWorkOrderOptions(startFilters.workOrderIds)
        }
        if (startFilters.proposalIds && startFilters.proposalIds.length > 0) {
            setProposalOptions(startFilters.proposalIds)
        }
    }, [])

    return <Modal
        show={true}
        onHide={onHide}
        backdrop="static"
        id="questionnaire-filter-modal"
        className="heightAuto fontIOS"
    >
        <Modal.Header>
            <Modal.Title>Filter</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Row className="padding-top-bottom-8">
                <Col sm={8} xs={12}>
                    <Select className="Select"
                            classNamePrefix="select"
                            menuPortalTarget={document.body}
                            styles={{ menuPortal: base => ({ ...base, zIndex: 9000 }) }}
                            value={select(customerOptions, filters?.customerIds?.map(e => e.value))}
                            options={customerOptions}
                            placeholder="Customers"
                            isDisabled={loadingCustomers}
                            isClearable
                            isMulti
                            isLoading={loadingCustomers}
                            onInputChange={(e) => customerDelayedSearch(e, filters)}
                            onChange={(e) => {
                                filters.customerIds = e
                                setFilters({...filters})
                            }}
                    />
                    <Select className="Select mt10"
                            classNamePrefix="select"
                            menuPortalTarget={document.body}
                            styles={{ menuPortal: base => ({ ...base, zIndex: 9000 }) }}
                            value={select(workOrderOptions, filters?.workOrderIds?.map(e => e.value))}
                            options={workOrderOptions}
                            placeholder="Work Orders"
                            isDisabled={loadingWorkOrder}
                            isClearable
                            isMulti
                            isLoading={loadingWorkOrder}
                            onInputChange={(e) => workOrderDelayedSearch(e, filters)}
                            onChange={(e) => {
                                filters.workOrderIds = e
                                setFilters({...filters})
                            }}
                    />
                    <Select className="Select mt10"
                                           classNamePrefix="select"
                                           menuPortalTarget={document.body}
                                           styles={{menuPortal: base => ({...base, zIndex: 9000})}}
                                           value={select(proposalOptions, filters?.proposalIds?.map(e => e.value))}
                                           options={proposalOptions}
                                           placeholder="Proposals"
                                           isDisabled={loadingProposal}
                                           isClearable
                                           isMulti
                                           isLoading={loadingProposal}
                                           onInputChange={(e) => proposalDelayedSearch(e, filters)}
                                           onChange={(e) => {
                                               filters.proposalIds = e
                                               setFilters({...filters})
                                           }}
                    />
                </Col>
            </Row>
        </Modal.Body>
        <Modal.Footer>
            <Button
                bsSize="small"
                bsStyle="warning"
                onClick={() => onHide()}
            >
                Close
            </Button>
            <Button
                bsSize="small"
                bsStyle="success"
                onClick={() => {
                    onSave(filters)
                    onHide()
                }}
            >
                Save
            </Button>
        </Modal.Footer>
    </Modal>
}

export default JSAFilterModal;